import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ResponseForm} from '../../../common/components/form/models/responsedemat.model';

@Component({
  selector: 'app-modale-response',
  templateUrl: './modale-response.component.html',
  styleUrls: ['./modale-response.component.scss']
})
export class ModaleResponseComponent implements OnInit {
  response: ResponseForm = null;
  constructor(@Inject(MAT_DIALOG_DATA) public data: ResponseForm,
              public dialogRef: MatDialogRef<ModaleResponseComponent>) { }

  ngOnInit(): void {
    if (this.data) {
      this.response = this.data;
    }
  }

}
